export default (to, from, next) => {
  if (to.meta.guestGuard && !to.meta.directLink) {
    next("/");
  } else {
    next();
  }
};
